import Vue from 'vue';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
  // timeout: 10000,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const endpoint = config.url.startsWith('https://graph.microsoft.com/') ? 'graph' : 'api';
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = await Vue.prototype.$auth.getToken(endpoint);
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
